import LocationDto from '@/models/Locations/LocationDto';
import BranchDto from '@/models/Branches/BranchDto';
import BaseCompanyScopeEntityDto from '@/models/Shared/BaseCompanyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import DeskDto from '@/models/Desks/DeskDto';
import ContactDto from '@/models/Contacts/ContactDto';
import PositionDto from '@/models/Positions/PositionDto';
import SkillDto from '@/models/Skills/SkillDto';
import QualificationDto from '@/models/Qualifications/QualificationDto';
import UserDto from '@/models/Users/UserDto';
import JobStatus from '@/models/Jobs/JobStatus';
import JobType from '@/models/Jobs/JobType';
import JobFeeSource from '@/models/Jobs/JobFeeSource';
import JobClosedReason from '@/models/Jobs/JobClosedReason';
import DepartmentDto from '@/models/Departments/DepartmentDto';
import JobStage from '@/models/Jobs/JobStage';
import IJob from '@/models/Jobs/IJob';

export default class JobDto extends BaseCompanyScopeEntityDto implements IJob {
    sequenceNumber = 0;
    status: JobStatus = JobStatus.Open;
    ownerId = '';
    owner: AgencyUserDto = new AgencyUserDto();
    branchId = '';
    branch: BranchDto = new BranchDto();
    deskId = '';
    desk: DeskDto = new DeskDto();
    locationId = '';
    location: LocationDto = new LocationDto();
    contactId = '';
    contact: ContactDto = new ContactDto();
    departmentId = '';
    department: DepartmentDto = new DepartmentDto();
    title = '';
    headcount = 0;
    workersPlaced = 0;
    type: JobType = JobType.Permanent;
    closingDate: Date;
    desiredStartDate: Date;
    annualSalaryMin = 0;
    annualSalaryMax = 0;
    feeSource: JobFeeSource = JobFeeSource.RateCard;
    //feePercentage: number = 0;
    //feeFlat: number = 0;
    purchaseOrderNumber = '';
    isTest = false;
    testEmailAddresses = '';
    summary = '';
    description = '';
    primaryPositionId = '';
    primaryPosition: PositionDto = new PositionDto();
    secondaryPositions: PositionDto[] = [];
    primarySkills: SkillDto[] = [];
    secondarySkills: SkillDto[] = [];
    primaryQualifications: QualificationDto[] = [];
    secondaryQualifications: QualificationDto[] = [];
    latestStage: JobStage = JobStage.Pending;
    latestStageAt: Date;
    latestStageById = '';
    latestStagedBy: UserDto = new UserDto();
    lastClosedAt: Date;
    lastClosedById = '';
    lastClosedBy: UserDto = new UserDto();
    lastClosedReason: JobClosedReason = JobClosedReason.Undefined;
}
